import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HookSection() {
  return <section className="py-24 bg-cream text-text-dark" data-id="element-63">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-64">
        <FadeIn data-id="element-65">
          <p className="text-2xl md:text-3xl lg:text-4xl font-serif italic leading-relaxed mb-10 text-navy" data-id="element-66">
            ¿Estás cansado de escuchar la palabra{' '}
            <span className="text-red-600 font-bold not-italic" data-id="element-67">"NO"</span>? No
            para ese auto que tu familia necesita, no para el apartamento que
            quieres rentar, y no para el préstamo que te daría tranquilidad.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-68">
          <p className="text-lg md:text-xl font-sans text-text-muted leading-relaxed max-w-3xl mx-auto" data-id="element-69">
            Tener un puntaje bajo en Estados Unidos no es una sentencia de por
            vida, es un{' '}
            <strong className="text-navy font-semibold" data-id="element-70">
              error de información
            </strong>{' '}
            que puedes corregir hoy mismo desde tu mesa de comedor.
          </p>
        </FadeIn>
      </div>
    </section>;
}